module.exports = __webpack_public_path__ + "static/media/home_grid_item_4.3cc1a6eb.png";